<template>
  <div class="admin__home">
    <Header />
    <div class="admin__home--left-div">
      <Sidebar :item="item" />
    </div>
    <div class="admin__home--right-div">
      <div>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../partials/header";
import Sidebar from "../../partials/sidebar";

export default {
  name: "referral",
  components: {
    Header,
    Sidebar
  },
  data() {
    return { item: "referral" };
  }
};
</script>

<style lang="scss" scoped>
</style>
